var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { DisplayTargetService } from './target.service';
import { UnitService } from '../../../service/unit.service';
import { Unit } from '../../../models/unit/unit';
import { ItemBase } from '../../../models/item/item-base';
var DisplayTargetComponent = /** @class */ (function (_super) {
    __extends(DisplayTargetComponent, _super);
    function DisplayTargetComponent(service, baseService, dtservice, uservice, cdRef) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.dtservice = dtservice;
        _this.uservice = uservice;
        _this.cdRef = cdRef;
        _this.cols = {};
        _this.nonMemberKey = '';
        _this.memberKey = '';
        _this.segmentKey = '';
        _this.unitSubscription = _this.uservice.get().subscribe(function (unit) {
            if (Unit.isUnit(unit)) {
                _this.currentUnit = unit;
                _this.cdRef.detectChanges();
            }
        });
        return _this;
    }
    DisplayTargetComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        var params = this.col.params || {};
        var non_member = params.non_member && params.non_member.key ? params.non_member.key : '';
        if (non_member) {
            this.nonMemberKey = this.baseService.getColKey(this.componentName, non_member, this.index);
            this.cols['non_member'] = Object.assign(new ItemBase(), {
                key: non_member,
                controlType: 'checkbox',
                readonly: this.col.readonly
            });
        }
        var member = params.member && params.member.key ? params.member.key : '';
        if (member) {
            this.memberKey = this.baseService.getColKey(this.componentName, member, this.index);
            this.cols['member'] = Object.assign(new ItemBase(), {
                key: member,
                controlType: 'checkbox',
                readonly: this.col.readonly
            });
        }
        var segment = params.segment && params.segment.key ? params.segment.key : '';
        if (segment) {
            this.segmentKey = this.baseService.getColKey(this.componentName, segment, this.index);
            this.dtservice.getSegmentList().subscribe(function (rec) {
                if (rec instanceof Array) {
                    _this.cols['segment'] = Object.assign(new ItemBase(), {
                        key: segment,
                        controlType: 'select',
                        readonly: _this.col.readonly,
                        params: { options: rec }
                    });
                    _this.cdRef.detectChanges();
                }
            });
        }
    };
    DisplayTargetComponent.prototype.onChangeVal = function (e1, e2) {
        this.changeValFlg = true;
        this.changeVal.emit({ key: e2, val: e1 });
        if (this.cols['member'] && this.cols['segment'] && this.cols['member'].key === e2 && !e1) {
            this.changeVal.emit({ key: this.cols['segment'].key, val: '' });
        }
    };
    DisplayTargetComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.unitSubscription.unsubscribe();
    };
    DisplayTargetComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-displaytarget',
                    template: "<ul [key]=\"key\" [col]=\"col\" columnDir>\n  <ng-template [ngIf]=\"cols.non_member && currentUnit?.id === 1\">\n    <li *ngIf=\"!cols.non_member.readonly\" class=\"form_li\">\n      <input type=\"checkbox\" id=\"{{ nonMemberKey }}\" name=\"{{ nonMemberKey }}\" [checked]=\"val[cols.non_member.key]\" (change)=\"onChangeVal(!val[cols.non_member.key], cols.non_member.key)\" [key]=\"key\" [col]=\"cols.non_member\" columnDir>\n      <label for=\"{{ nonMemberKey }}\" [key]=\"key\" [col]=\"cols.non_member\" columnDir>{{ msg['DisplayTargetComponent.checkbox.nonMember'] }}</label>\n    </li>\n    <li *ngIf=\"cols.non_member.readonly && val[cols.non_member.key]\" class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"{key: cols.non_member.key, controlType: 'text'}\" [val]=\"msg['DisplayTargetComponent.checkbox.nonMember']\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n  <ng-template [ngIf]=\"cols.member\">\n    <li *ngIf=\"!cols.member.readonly\" class=\"form_li\">\n      <input type=\"checkbox\" id=\"{{ memberKey }}\" name=\"{{ memberKey }}\" [checked]=\"val[cols.member.key]\" (change)=\"onChangeVal(!val[cols.member.key], cols.member.key)\" [key]=\"key\" [col]=\"cols.member\" columnDir>\n      <label for=\"{{ memberKey }}\" [key]=\"key\" [col]=\"cols.member\" columnDir>{{ msg['DisplayTargetComponent.checkbox.member'] }}</label>\n    </li>\n    <li *ngIf=\"cols.member.readonly && val[cols.member.key]\" class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"{key: cols.member.key, controlType: 'text'}\" [val]=\"msg['DisplayTargetComponent.checkbox.member']\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n  <ng-template [ngIf]=\"cols.segment && !cols.segment.readonly\">\n    <li class=\"form_li form_li-break\"></li>\n    <li class=\"form_li\">\n      <select name=\"{{ segmentKey }}\" attr.name=\"{{ segmentKey }}\" [(ngModel)]=\"val[cols.segment.key]\"\n              (change)=\"onChangeVal(val[cols.segment.key], cols.segment.key)\" [key]=\"key\" [col]=\"cols.segment\" columnDir [disabled]=\"!val[cols.member.key]\">\n        <option value=\"\"></option>\n        <option *ngFor=\"let option of cols.segment.params.options; trackBy: trackByOption\" [value]=\"option.code\">{{ option.display }}</option>\n      </select>\n    </li>\n  </ng-template>\n  <ng-template [ngIf]=\"cols.segment && cols.segment.readonly && val[cols.member.key]\">\n    <li class=\"form_li form_li-break\"></li>\n    <li class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols.segment\" [val]=\"val[cols.segment.key]\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n</ul>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    DisplayTargetComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: DisplayTargetService },
        { type: UnitService },
        { type: ChangeDetectorRef }
    ]; };
    DisplayTargetComponent.propDecorators = {
        non_member: [{ type: Input }],
        member: [{ type: Input }],
        segment: [{ type: Input }]
    };
    return DisplayTargetComponent;
}(ColumnBaseComponent));
export { DisplayTargetComponent };
//# sourceMappingURL=target.component.js.map